"use client";
import { useContext } from "react";
import ResponsiveMenuContext from "@/contexts/responsiveMenu.context";

type LinkMenuProps = {
  children: React.ReactNode;
  className?: string;
};

const LinkMenu = ({ children, className }: LinkMenuProps) => {
  const { isResponsiveMenuDisplayed, setIsResponsiveMenuDisplayed } =
    useContext(ResponsiveMenuContext);

  return (
    <div className={className} onClick={() => setIsResponsiveMenuDisplayed(false)}>
      {children}
    </div>
  );
};

export default LinkMenu;
